export const PROCESS_URL = '/process';